import {
  B_18,
  BANNER_DEFAULTS,
  hideB18Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B18_PLASMIC_PROPS = {
  b18Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_18].heading,
    description: "Main heading (B18 only)",
    hidden: hideB18Props,
  },
  b18Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_18].description,
    description: "Description text (B18 only)",
    hidden: hideB18Props,
  },
  b18PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_18].primaryButtonText,
    description: "Primary CTA button text (B18 only)",
    hidden: hideB18Props,
  },
  b18PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_18].primaryButtonUrl,
    description: "Primary CTA button URL (B18 only)",
    hidden: hideB18Props,
  },
  b18Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_18].image,
    description: "Main image (B18 only)",
    hidden: hideB18Props,
  },
  b18ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_18].imageAlt,
    description: "Image alt text (B18 only)",
    hidden: hideB18Props,
  },
};
